<script lang="ts">

const PostProgressEnum =
{
  None: 0,
  WaitUserModeration: 10,
  Cancelled: 40,
  ReadyToSubmit: 50,
  Submitted: 100
}

export default PostProgressEnum;

</script>